const CustomFooter = props => {
  return (
    <p className={`clearfix mb-0 ${props.className}`}>
      <span className='float-md-left d-block d-md-inline-block mt-25'>
        Copyright © {new Date().getFullYear()}{' '}
        <span className='d-none d-sm-inline-block'> <a href="http://brasal.com.br"> Brasal</a> - Todos os direitos reservados</span>
      </span>
    </p>
  )
}

export default CustomFooter

